import React from "react";
import "./loyaltyProgramCards.scss";
import LoyaltyProgramCard from "./LoyaltyProgramCard";
import { ITier } from "redux/reducers/models/loyalty";

interface IProps {
    points: number;
    expiringPoints: number;
    tiers: Array<ITier>;
    currentTierId: number;
}

export default function LoyaltyProgramCards(props: IProps) {
    const {points, expiringPoints, tiers, currentTierId} = props;

    return (
        <div className="loyalty-program-cards">
                {tiers && tiers?.length > 0 ? (
                    <LoyaltyProgramCard type="tier" points={points} tiers={tiers} currentTierId={currentTierId} />
                ) : null}
                <LoyaltyProgramCard type="points" points={points} />
                <LoyaltyProgramCard type="expiry" points={points} expiringPoints={expiringPoints} />
        </div>
    );
}